import pickBy from 'lodash/pickBy'
import FilterComponents from 'components/Filters/FilterPanel/subcomponents'
import React from 'react'

const extractComponents = (filterManager = {}, position, ControlWrapper) => {
  const { configuration } = filterManager

  return Object.entries(pickBy(configuration, (item) => item.order === position) ?? {}).map(
    ([key, values]) => {
      const El = FilterComponents[values.typeAsButtonControl ?? values.type]

      return El ? (
        <ControlWrapper key={'filter-' + position + '-' + key}>
          <El
            name={key}
            filterManager={filterManager}
            {...values}
            value={filterManager?.filters?.[key]}
            onApply={(val) => filterManager.updateFilter({ fieldName: key, value: val })}
          />
        </ControlWrapper>
      ) : null
    },
  )
}

export default extractComponents
